const VideoFileUrlParser = {};
const DOWNLOADS_CDN_HOST = 'downloads.intercomcdn.com';
const VIDEO_FILE_CDN_HOST = 'video-messages.intercomcdn.com';
VideoFileUrlParser.replaceUploadsDomain = function (url) {
  if (url) {
    return url.replace(DOWNLOADS_CDN_HOST, VIDEO_FILE_CDN_HOST);
  }
};
export default VideoFileUrlParser;